import { Badge, Button, Input, List, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import { ICallee, StatusCalleeType } from '../../stores/DialerStore';
import { useStore } from '../../stores';

import './DialerView.scss';
import { EntityItem } from '@/components/EntityItem/EntityItem';
import { EEntity } from '@/services/dynamics/enums/entity.enum';
import { Dynamics } from '@/services/dynamics/dynamics';
import { IEntity } from '@/shared/interfaces/entity.interface';

const { Search } = Input;
const { Title } = Typography;

type StatusCalleeMapType = { [K in StatusCalleeType]: string };

const statusCallee: StatusCalleeMapType = {
  active: 'red',
  pending: 'blue',
  completed: 'green',
};

export const DialerView = observer(() => {
  const {
    dialerStore: { activeDialer, removeCallee },
  } = useStore();
  const [isOpeningEntity, setOpeningEntity] = useState<boolean>(false);
  const [list, setList] = useState<ICallee[]>(activeDialer);

  useEffect(() => {
    setList(activeDialer);
  }, [activeDialer]);

  const onSearch = async (value: string) => {
    const clearValue = value.trim().toLowerCase();

    const filteredList = activeDialer.filter(({ user }) => {
      const name = user.fullName.toLowerCase();
      return name.includes(clearValue);
    });
    setList(filteredList);
  };

  const onDelete = (user: IEntity) => {
    removeCallee(user);
  };

  const openEntity = async (id: string, type: EEntity) => {
    if (isOpeningEntity) {
      return;
    }
    setOpeningEntity(true);
    await Dynamics.openEntity(id, type);
    setOpeningEntity(false);
  };

  return (
    <div className="dialer-view">
      <div className="dialer-view__header">
        <Title level={5}>Dialer View</Title>
      </div>
      <Search placeholder="Find by name" allowClear onSearch={onSearch} />
      <List
        className="dialer-view__content"
        dataSource={list}
        renderItem={({ status, user }) => (
          <List.Item className={`dialer-view__item ${status}`} key={user.id}>
            <div className="dialer-view__item-info">
              <Badge color={statusCallee[status]} text={status} />

              <EntityItem onOpenEntity={openEntity} user={user}></EntityItem>
            </div>
            {status === 'pending' ? (
              <Button
                data-testid="delete-callee"
                danger
                onClick={() => onDelete(user)}
                type="text"
                shape="circle"
                icon={<DeleteOutlined />}
              />
            ) : (
              <></>
            )}
          </List.Item>
        )}
      />
    </div>
  );
});
